export const ENTRY_FORMS = `
  query entryForms(
    $tenant_id: Int!
    $skip: Int
    $take: Int
    $orderBy: EntryFormOrderInput
    $filter: FilterEntryFormInput
    $searchText: String
  ) {
    entryForms(
      tenant_id: $tenant_id
      skip: $skip
      take: $take
      orderBy: $orderBy
      filter: $filter
      searchText: $searchText
    ) {
      __typename
      ... on EntryForm {
        id
        contact_id
        contact {
          id
          firstname
          lastname
          email
        }
        responsible_id
        responsible {
          id
          firstname
          lastname
        }
        group_id
        group {
          id
          name
          member_count
        }
        status_id
        entry_form_status {
          id
          name
          hex_color
        }
        program_id
        program {
          id
          name
        }
        variant_id
        program_variant {
          id
          name
        }
        date_from
        referred_by
        referred_by_free_text
        referrer {
          id
          firstname
          lastname
        }
        its
        uts
        company_name
        company_cuit
        prospect_email
        referred_by_type
        referred_by_free_text
        token
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const ENTRY_FORMS_COUNT = `
  query entryFormsCount(
    $tenant_id: Int!
    $filter: FilterEntryFormInput
    $searchText: String
  ) {
    entryFormsCount(
      tenant_id: $tenant_id
      filter: $filter
      searchText: $searchText
    ) {
      __typename
      ... on Count {
        count
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const GET_ENTRY_FORM = `
  query entryForm($id: Int!, $tenant_id: Int!) {
    entryForm(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on EntryForm {
        id
        contact_id
        contact {
          id
          firstname
          lastname
          email
          phone
          mobile
          company_id
          company { id name cuit }
        }
        responsible_id
        responsible {
          id
          firstname
          lastname
          email
        }
        group_id
        group { id name member_count }
        status_id
        entry_form_status { id name hex_color }
        program_id
        program { id name }
        variant_id
        program_variant { id name }
        program_pricing_id
        program_pricing { id monthly_fee signup }
        date_from
        prospect_email
        company_name
        firstname
        lastname
        dni
        gender
        phone
        birth_date
        position_id
        company_fantasy_name
        company_cuit
        company_website
        company_phone
        company_fiscal_address
        company_fiscal_zip_code
        company_fiscal_province
        fiscal_province { id name }
        company_fiscal_city
        company_commercial_address
        company_commercial_zip_code
        company_commercial_province
        commercial_province { id name }
        company_commercial_city
        referred_by
        referrer { id firstname lastname }
        invoice_email
        charging_contact_name
        charging_contact_phone
        charging_contact_email
        bill_type
        payment_type
        special_payment_method
        authorizations
        installment_payment
        is_reentry
        referred_by_type
        referred_by_other
        industry
        employees
        income
        company_status
        company_type
        referred_by_counselor
        referred_by_event
        referred_by_free_text
        is_lead
        is_gdi
        signature
        signature_url
        authorizations
        authorizations_url
        comments
        its
        uts
        bank_account_owner
        bank_account_cbu
        bank_account
        bank_account_number
        card_type
        card_number
        card_due_date
        custom_monthly_fee
        custom_signup
        entry_form_benefit {
          id
          benefit_id
          benefit {
            id
            name
            company_number
            monthly_fee_discount
            signup_discount
            active
          }
        }
        token
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const ENTRY_FORM_STATUSES = `
  query entryFormStatuses($tenant_id: Int!) {
    entryFormStatuses(tenant_id: $tenant_id) {
      __typename
      ... on EntryFormStatus {
        id
        name
        hex_color
        allow_manual
        active
        position
        initial_status
        end_status
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const AVAILABLE_ENTRY_FORM_ACTIONS = `
  query availableEntryFormActions(
    $tenant_id: Int!
    $input: AvailableEntryFormActionsInput!
    $chair_id: Int
  ) {
    availableEntryFormActions(tenant_id: $tenant_id, input: $input, chair_id: $chair_id) {
      __typename
      ... on EntryFormAction {
        id
        name
        translation_key
        is_main_action
        multiple
        level
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const GET_ENTRY_FORM_BY_TOKEN = `
  query getEntryFormByToken($token: String!) {
    getEntryFormByToken(token: $token) {
      __typename
      ... on EntryFormPublicData {
        token_status
        entry_form {
          id
          prospect_email
          company_name
          firstname
          lastname
          dni
          gender
          phone
          birth_date
          position_id
          company_fantasy_name
          company_cuit
          company_website
          company_phone
          company_fiscal_address
          company_fiscal_zip_code
          company_fiscal_province
          company_fiscal_city
          company_commercial_address
          company_commercial_zip_code
          company_commercial_province
          company_commercial_city
          invoice_email
          charging_contact_name
          charging_contact_phone
          charging_contact_email
          bill_type
          payment_type
          special_payment_method
          installment_payment
          signature
          effective_monthly_fee_discount
          effective_signup_discount
          responsible {
            id
            firstname
            lastname
          }
          program {
            id
            name
          }
          program_variant {
            id
            name
          }
          group {
            id
            name
            sponsored
          }
          program_pricing {
            id
            monthly_fee
            signup
            budget
          }
          referrer {
            id
            firstname
            lastname
          }
          bank_account_owner
          bank_account_cbu
          bank_account
          bank_account_number
          card_type
          card_number
          card_due_date
          industry
          employees
          income
          company_type
          date_from
          referred_by_free_text
        }
        provinces {
          id
          name
        }
        positions {
          id
          name
        }
        industries {
          id
          name
        }
        incomes {
          id
          name
        }
        signature_url
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const GET_ENTRY_FORM_PDF_URL = `
  query getEntryFormPdfUrl($id: Int!, $tenant_id: Int!) {
    getEntryFormPdfUrl(id: $id, tenant_id: $tenant_id) {
      url
    }
  }
`;
